import { useState } from 'react';
import { Splitter as MantineSplitter, SplitterProps as MantineSplitterProps } from '@mantine/core';
import classes from './AppSplitter.module.css';

export interface AppSplitterProps extends MantineSplitterProps {}

export function AppSplitter({
    classNames,
    styles,
    onResizeStart,
    onResizeEnd,
    handleColor,
    lineSize = 2,
    withHandle = false,
    resetOnDoubleClick = true,
    ...rest
}: AppSplitterProps) {
    const [isDragging, setIsDragging] = useState(false);

    return (
        <MantineSplitter
            lineSize={lineSize}
            withHandle={withHandle}
            resetOnDoubleClick={resetOnDoubleClick}
            handleColor={
                handleColor ?? (isDragging ? 'var(--mantine-color-blue-6)' : 'var(--mantine-color-default-border)')
            }
            onResizeStart={(index) => {
                setIsDragging(true);
                onResizeStart?.(index);
            }}
            onResizeEnd={(index, sizes) => {
                setIsDragging(false);
                onResizeEnd?.(index, sizes);
            }}
            classNames={
                typeof classNames === 'object' && classNames !== null
                    ? {
                          ...classNames,
                          handle: `${classes.splitterHandle} ${(classNames as Record<string, string>).handle ?? ''}`.trim(),
                      }
                    : { handle: classes.splitterHandle }
            }
            styles={styles}
            {...rest}
        />
    );
}

AppSplitter.Pane = MantineSplitter.Pane;
